module.exports = __webpack_public_path__ + "img/tiktok.ef15d4b6.svg";